import { createContext, useContext, useEffect, useState } from 'react';
const ThemeContext = createContext();
const deviceTheme = () => window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
function savedPreference() {
  try { const value = localStorage.getItem('namecamper-theme'); return ['light', 'dark', 'system'].includes(value) ? value : 'system'; } catch { return 'system'; }
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within a ThemeProvider');
  return context;
}
export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(savedPreference);
  const [systemTheme, setSystemTheme] = useState(deviceTheme);
  const resolvedTheme = theme === 'system' ? systemTheme : theme;
  useEffect(() => {
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    const change = event => setSystemTheme(event.matches ? 'dark' : 'light');
    query.addEventListener('change', change);
    return () => query.removeEventListener('change', change);
  }, []);
  useEffect(() => {
    document.documentElement.dataset.theme = resolvedTheme;
    try { localStorage.setItem('namecamper-theme', theme); } catch { /* Theme remains usable when storage is unavailable. */ }
  }, [theme, resolvedTheme]);
  const setPreference = value => { if (['light', 'dark', 'system'].includes(value)) setTheme(value); };
  return <ThemeContext.Provider value={{ theme, resolvedTheme, setTheme: setPreference, isSystemTheme: theme === 'system', toggleTheme: () => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark') }}>{children}</ThemeContext.Provider>;
}
